import { createFileRoute } from "@tanstack/react-router";
import { Bell } from "lucide-react";
import { SETTINGS_HEADER_CLASS } from "@/components/ui/setting-row";
import NotificationSettings from "@/components/settings/notification-settings";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import {
  NotificationEmailTemplatesCard,
  ScriptEmailTemplatesCard,
} from "@/components/email-templates/notification-email-templates";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/notifications",
)({
  component: NotificationsSettingsPage,
});

function NotificationsSettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "notifications", actions: ["read", "update"] }]}
    >
      {/* Formato de Configuración → Colecciones, como Empresa y Seguridad. */}
      <div className="flex min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-2 pb-6">
          <div className={SETTINGS_HEADER_CLASS}>
            <div className="flex items-center gap-2.5">
              <div className="flex size-10 shrink-0 items-center justify-center rounded-md border border-border bg-background">
                <Bell className="h-4 w-4 text-muted-foreground" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold">Notificaciones</p>
                <p className="text-[11px] text-muted-foreground">
                  Políticas de notificación de toda la empresa y el diseño de los correos que se envían.
                </p>
              </div>
            </div>
          </div>
          <NotificationSettings />
          <NotificationEmailTemplatesCard />
          <ScriptEmailTemplatesCard />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
